<script setup lang="ts">
import { computed } from 'vue'
import { useAppStore } from '../store'
const store = useAppStore()
const text = computed(() => {
  const s = store.sync
  if (!store.online) return store.t('offline')
  if (s.state === 'running') return `${store.t('syncing')} ${s.done} / ${s.total}`
  if (s.state === 'failed') return `${store.t('syncFailed')}${s.message ? ': ' + s.message : ''}`
  return null
})
const cls = computed(() => (!store.online ? 'offline' : store.sync.state === 'failed' ? 'failed' : ''))
</script>

<template>
  <div v-if="text" class="syncbar" :class="cls">{{ text }}</div>
</template>
